import type { WhiteboardDocumentId } from "@src/components/collaboration/document-id";
import { capture, captureWithBoardId } from "./core";
import type {
	AuthProvider,
	SharePanelLinkContext,
	UpgradeTriggerSource,
	WhatsappModalOpenSource,
} from "./types";

export function captureUserSignedUp(
	provider: AuthProvider,
	fromDemo: boolean,
	hasReferral: boolean,
) {
	capture("user_signed_up", {
		provider,
		from_demo: fromDemo,
		has_referral: hasReferral,
	});
}

export function captureOnboardingCompleted() {
	capture("onboarding_completed");
}

export function captureUpgradePlanModalOpened(source: UpgradeTriggerSource) {
	capture("upgrade_plan_modal_opened", { source });
}

export function captureInvitationLinkCopied() {
	capture("invitation_link_copied");
}

export function captureRewardClaimed(rewardCode: string) {
	capture("reward_claimed", { reward_code: rewardCode });
}

export function captureWhatsappModalOpened(source: WhatsappModalOpenSource) {
	capture("whatsapp_modal_opened", { source });
}

export function captureNavbarItemReordered(section: string) {
	capture("navbar_item_reordered", { section });
}

export function captureNavbarFolderCreated(section: string) {
	capture("navbar_folder_created", { section });
}

export function captureBoardSearchUsed(resultCount: number) {
	capture("board_search_used", { result_count: resultCount });
}

export function captureBoardShared(
	boardId: WhiteboardDocumentId,
	recipientCount: number,
) {
	captureWithBoardId("board_shared", boardId, {
		recipient_count: recipientCount,
	});
}

export function captureBoardPublishToggled(
	boardId: WhiteboardDocumentId,
	enabled: boolean,
) {
	captureWithBoardId("board_publish_toggled", boardId, { enabled });
}

export function captureCollaboratorFollowed(boardId: WhiteboardDocumentId) {
	captureWithBoardId("collaborator_followed", boardId);
}

export function captureSharePanelLinkCopied(
	boardId: WhiteboardDocumentId,
	context: SharePanelLinkContext,
) {
	captureWithBoardId("share_panel_link_copied", boardId, { context });
}

export function captureQrCodeDownloaded(
	boardId: WhiteboardDocumentId,
	context: SharePanelLinkContext,
) {
	captureWithBoardId("qr_code_downloaded", boardId, { context });
}
